module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/zawieszenie@3x-4be6965b.svg";